import React, { lazy, Suspense } from 'react'

const LazyComponent = lazy(() => import(/* webpackChunkName: "recaptcha" */ './'))

export default function CaptchaStandaloneLazy(props) {
  return (
    <Suspense fallback={null}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
